// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8e1b4df9","442":"31442af1","453":"5851f4bb","691":"1204f6da","745":"dcc9308a","772":"003cde64","820":"c1a96681","987":"8388a285"}[chunkId] + ".chunk.js";
};